var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-x grid-margin-x"},[_c('div',{staticClass:"cell auto"},[_c('data-table',{attrs:{"icon":"icon-menu-profile","title":_vm.$t('metrics.assets_usage'),"headers":_vm.asset_headers,"items":_vm.assets}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }